export const medalInfo = [
  {
    name: '1 Ply Paper Towel',
    earn: 'Have at least 4 angel cards (not including Berakiel)',
    burn: 'Burn 1 Ply, 2 Ply, Cardboard and Bronze to get an accessory',
    restrictions: 'Claimable 1x per angel card',
    cost: 10,
  },
  {
    name: '2 Ply Paper Towel',
    earn: 'Have all 4 level 1 pets',
    burn: 'Burn 1 Ply, 2 Ply, Cardboard and Bronze to get an accessory',
    restrictions: 'Claimable 1x per l1 pet card',
    cost: 15,
  },
  {
    name: 'Cardboard',
    earn: 'Have one angel card with at least 350 exp',
    burn: 'Burn 1 Ply, 2 Ply, Cardboard and Bronze to get an accessory',
    restrictions: 'Claimable 1x per angel card',
    cost: 15,
  },
  {
    name: 'Bronze',
    earn: 'Have all 4 level 2 pets',
    burn: 'Burn 1 Ply, 2 Ply, Cardboard and Bronze to get an accessory',
    restrictions: 'Claimable 1x per level 2 pet card',
    cost: 20,
  },
  {
    name: 'Silver',
    earn: 'Have a red, green, purple and yellow angel',
    burn: 'Plus 5-10 bp for one angel card',
    restrictions: 'Claimable 1x per angel card',
    cost: 25,
  },
  {
    name: 'Gold',
    earn: 'Make it on the main battle mountain',
    burn: 'Plus 50 exp for one angel card',
    restrictions: 'Claimable 1x per angel card',
    cost: 0,
  },
  {
    name: 'Platinum',
    earn: 'Have all 4 level 3 pets',
    burn: 'Plus 50 of one Aura color to one pet',
    restrictions: 'Claimable 1x per level 3 pet card',
    cost: 35,
  },
  {
    name: 'Stupid Fluffy Pink',
    earn: 'Have all 4 level 4 pets',
    burn: 'Plus 75 of one Aura color to one pet',
    restrictions: 'Claimable 1x per level 4 pet card',
    cost: 40,
  },
  {
    name: 'Orichalcum',
    earn: 'Acquire at least one elemental',
    burn: 'Plus 100 of one Aura color to one pet',
    restrictions: 'Claimable 1x per elemental card',
    cost: 45,
  },
  {
    name: 'Diamond',
    earn: 'Make it to panel 1 on battle mountain',
    burn: 'Plus 200 exp to one angel',
    restrictions: 'Claimable 1x per angel card',
    cost: 50,
  },
  {
    name: 'Titanium',
    earn: 'Automatically awarded on defeat of Liquid Metal Cornu',
    burn: 'Top up Pet Speed',
    restrictions:
      'Claimable on every victory, but LMC becomes stronger when defeated by any player',
    cost: 0,
  },
  {
    name: 'Zeronium',
    earn: 'Make it to spot 1 on battle mountain',
    burn: 'Plus 15-25 bp for one angel',
    restrictions: 'Claimable 1x per angel card',
    cost: 0,
  },
];
